import { useState } from 'react'
import {
  FaEnvelope,
  FaPhone,
  FaLocationDot,
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaTelegram,
  FaArrowRight,
} from 'react-icons/fa6'
import Toast from '../../../hooks/useToast'

const contacts = [
  { icon: FaEnvelope, label: 'Email', value: 'info@radiustrend.id' },
  { icon: FaPhone, label: 'Telepon', value: '+62 812-3456-7890' },
  { icon: FaLocationDot, label: 'Kantor', value: 'Bandung, Jawa Barat, Indonesia' },
]

const socials = [
  { icon: FaInstagram, label: 'Instagram' },
  { icon: FaFacebookF, label: 'Facebook' },
  { icon: FaYoutube, label: 'YouTube' },
  { icon: FaTelegram, label: 'Telegram' },
]

export default function LpCTASection() {
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' })
  const [form, setForm] = useState({ name: '', email: '', phone: '', isp: '' })
  const [errors, setErrors] = useState({})

  const validate = () => {
    const e = {}
    if (!form.name.trim()) e.name = 'Nama wajib diisi'
    if (!form.email.trim()) e.email = 'Email wajib diisi'
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      e.email = 'Format email tidak valid'
    if (!form.phone.trim()) e.phone = 'Nomor telepon wajib diisi'
    else if (!/^[0-9+\-\s()]{8,15}$/.test(form.phone))
      e.phone = 'Format nomor tidak valid'
    if (!form.isp.trim()) e.isp = 'Nama ISP wajib diisi'
    setErrors(e)
    return Object.keys(e).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!validate()) return
    setToast({
      show: true,
      message:
        'Terima kasih! Tim kami akan menghubungi Anda dalam 1x24 jam.',
      type: 'success',
    })
    setForm({ name: '', email: '', phone: '', isp: '' })
    setErrors({})
    setTimeout(() => setToast((t) => ({ ...t, show: false })), 5000)
  }

  const handleChange = (field) => (e) => {
    setForm((f) => ({ ...f, [field]: e.target.value }))
    if (errors[field])
      setErrors((err) => ({ ...err, [field]: undefined }))
  }

  const inputCls = (field) =>
    `w-full bg-navy-700/50 border ${
      errors[field] ? 'border-red-500/60' : 'border-navy-500/40'
    } rounded-xl px-4 py-3.5 text-white text-sm placeholder-slate-custom/50 focus:outline-none focus:border-ocean-600/60 focus:ring-1 focus:ring-ocean-600/30 transition-all`

  return (
    <section
      id="kontak"
      className="relative py-24 lg:py-32 overflow-hidden"
      aria-labelledby="kontak-heading"
    >

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Kiri: Info */}
          <div className="reveal-left">
            <span className="text-ocean-600 font-semibold text-sm tracking-wider uppercase mb-4 block">
              Hubungi Kami
            </span>
            <h2
              id="kontak-heading"
              className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-6"
            >
              Siap Transformasi{' '}
              <span className="gradient-text">Bisnis ISP</span> Anda?
            </h2>
            <p className="text-slate-custom text-lg leading-relaxed mb-10">
              Daftar sekarang dan dapatkan trial gratis 14 hari tanpa syarat
              kartu kredit. Tim kami siap membantu Anda memulai.
            </p>

            <div className="space-y-5">
              {contacts.map((c, i) => {
                const Icon = c.icon
                return (
                  <div key={i} className="flex items-center gap-4">
                    <div className="w-11 h-11 rounded-xl bg-ocean-800/15 border border-ocean-700/20 flex items-center justify-center flex-shrink-0">
                      <Icon className="text-ocean-500 text-sm" />
                    </div>
                    <div>
                      <div className="text-xs text-slate-custom">{c.label}</div>
                      <div className="text-white text-sm font-medium">
                        {c.value}
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>

            <div className="flex gap-4 mt-10">
              {socials.map((s, i) => {
                const Icon = s.icon
                return (
                  <a
                    key={i}
                    href="#"
                    className="w-10 h-10 rounded-xl bg-navy-700/50 border border-navy-500/30 flex items-center justify-center text-slate-custom hover:text-ocean-500 hover:border-ocean-600/40 hover:bg-ocean-800/10 transition-all"
                    aria-label={s.label}
                  >
                    <Icon className="text-sm" />
                  </a>
                )
              })}
            </div>
          </div>

          {/* Kanan: Form */}
          <div className="reveal-right">
            <Toast
              message={toast.message}
              show={toast.show}
              type={toast.type}
            />
            <form
              onSubmit={handleSubmit}
              className="card-glow rounded-2xl p-8"
              noValidate
            >
              <h3 className="font-display font-semibold text-xl text-white mb-6">
                Daftar Trial Gratis
              </h3>
              <div className="space-y-4">
                <div>
                  <label
                    htmlFor="name"
                    className="block text-sm text-slate-custom mb-2"
                  >
                    Nama Lengkap
                  </label>
                  <input
                    id="name"
                    type="text"
                    value={form.name}
                    onChange={handleChange('name')}
                    placeholder="Masukkan nama lengkap"
                    className={inputCls('name')}
                  />
                  {errors.name && (
                    <p className="text-red-400 text-xs mt-1.5">{errors.name}</p>
                  )}
                </div>
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm text-slate-custom mb-2"
                  >
                    Email
                  </label>
                  <input
                    id="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange('email')}
                    placeholder="email@anda.com"
                    className={inputCls('email')}
                  />
                  {errors.email && (
                    <p className="text-red-400 text-xs mt-1.5">{errors.email}</p>
                  )}
                </div>
                <div>
                  <label
                    htmlFor="phone"
                    className="block text-sm text-slate-custom mb-2"
                  >
                    Nomor WhatsApp
                  </label>
                  <input
                    id="phone"
                    type="tel"
                    value={form.phone}
                    onChange={handleChange('phone')}
                    placeholder="0812xxxxxxxx"
                    className={inputCls('phone')}
                  />
                  {errors.phone && (
                    <p className="text-red-400 text-xs mt-1.5">{errors.phone}</p>
                  )}
                </div>
                <div>
                  <label
                    htmlFor="isp"
                    className="block text-sm text-slate-custom mb-2"
                  >
                    Nama ISP / RT/RW Net
                  </label>
                  <input
                    id="isp"
                    type="text"
                    value={form.isp}
                    onChange={handleChange('isp')}
                    placeholder="Contoh: JakWiFi Net"
                    className={inputCls('isp')}
                  />
                  {errors.isp && (
                    <p className="text-red-400 text-xs mt-1.5">{errors.isp}</p>
                  )}
                </div>
                <button
                  type="submit"
                  className="btn-primary w-full justify-center mt-2 text-base py-4"
                >
                  <span>Mulai Trial Gratis</span>
                  <FaArrowRight className="text-sm" />
                </button>
              </div>
              <p className="text-slate-custom/60 text-xs mt-5 text-center">
                Dengan mendaftar, Anda menyetujui kebijakan privasi kami. Data
                Anda aman dan tidak akan dibagikan ke pihak ketiga.
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}